import type { ApiClient } from '@hrms/shared';

/**
 * Push notifications are NOT wired yet (Firebase Cloud Messaging / APNs to be added later).
 * This stub keeps the call site in AuthProvider so wiring it later is a one-file change:
 * obtain the device token, then `api.ess.registerDevice({ token, platform })`.
 */
export async function registerForPush(_api: ApiClient): Promise<string | null> {
  return null;
}
